import {WidgetPosition} from "../api/generated";

export const calcTimeDiff = (localDateTime: string) => {
    const now = new Date();
    const time = new Date(localDateTime);

    let diff = now.getTime() - time.getTime();

    if (Math.round(diff / 1000) < 10) {
        return "Just Now";
    } else {
        return time.toLocaleTimeString();
    }
};

export const isDevEnv = (profile?: string) => {
    return profile && profile.toUpperCase() == "DEV";
}

export const handleLinkInChatClick = (e: any, href?: string, websiteLocation?: string, isNewWindow?: boolean) => {
    if (websiteLocation) {
        e.preventDefault();
        window.parent.postMessage(
            {
                type: 'open-link',
                href: href,
                inNew: isNewWindow,
            },
            websiteLocation
        );
    }
}

export const sendChangeWidgetPositionEvent = (widgetPosition: WidgetPosition, horizontalOffsetPx: number, verticalOffsetPx: number, websiteLocation: string) => {
    if (websiteLocation) {
        window.parent.postMessage(
            {
                type: "change-widget-position",
                bottom: verticalOffsetPx,
                ...(widgetPosition == WidgetPosition.Right
                    ? {right: horizontalOffsetPx}
                    : {left: horizontalOffsetPx}),
            },
            websiteLocation
        )
    }
}

export const getBaseUrl = (defaultUrl: string, url?: string) => {
    try {
        const baseUrl = url ?? defaultUrl
        const parsedUrl = new URL(baseUrl);
        if (parsedUrl.hostname === "localhost") {
            return `${parsedUrl.protocol}//${parsedUrl.hostname}:${parsedUrl.port}`;
        }
        return `${parsedUrl.protocol}//${parsedUrl.hostname}`;
    } catch (e) {
        console.error("Invalid URL: ", url, " Used default: ", defaultUrl);
        return defaultUrl;
    }
}
